window.addEventListener("load", () => {
  const modalOverlay = document.getElementById("video-modal-overlay");
  const modalContent = document.getElementById("video-modal-content");
  const modalVideoPlayer = document.getElementById("video-player");
  const modalVideoThumb = document.getElementById("videoThumbnail");
  const closeBtn = document.getElementById("close-video-modal-bottom");
  if (!closeBtn) return;

  const triggers = document.querySelectorAll(".video-container-trigger");

  function openModal(embedHtml) {
    let finalEmbed = embedHtml;
    if (finalEmbed.includes("youtube.com")) {
      if (finalEmbed.includes("?")) {
        finalEmbed = finalEmbed.replace("?", "?autoplay=1&rel=0&");
      } else {
        finalEmbed = finalEmbed.replace('src="', 'src="?autoplay=1&rel=0&');
      }
    } else if (finalEmbed.includes("vimeo.com")) {
      finalEmbed = finalEmbed.replace("?", "?autoplay=1&");
    }

    modalVideoPlayer.innerHTML = finalEmbed;
    const iframe = modalVideoPlayer.querySelector("iframe");
    if (iframe) {
      iframe.setAttribute("allow", "autoplay; fullscreen");
      iframe.classList.add("w-full", "h-full", "absolute", "inset-0");
    }

    modalVideoThumb.style.opacity = "0";
    modalVideoThumb.style.pointerEvents = "none";
    modalVideoPlayer.style.opacity = "1";
    modalVideoPlayer.style.pointerEvents = "auto";

    modalOverlay.classList.remove("hidden", "pointer-events-none");
    modalOverlay.style.display = "flex";

    setTimeout(() => {
      modalOverlay.classList.add("opacity-100");
      modalContent.classList.remove("scale-95");
      modalContent.classList.add("scale-100");
    }, 10);

    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modalOverlay.classList.remove("opacity-100");
    modalContent.classList.add("scale-95");
    modalContent.classList.remove("scale-100");

    setTimeout(() => {
      modalOverlay.classList.add("hidden", "pointer-events-none");
      modalOverlay.style.display = "none";

      modalVideoPlayer.innerHTML = "";
      modalVideoPlayer.style.opacity = "0";
      modalVideoPlayer.style.pointerEvents = "none";

      modalVideoThumb.style.opacity = "1";
      modalVideoThumb.style.pointerEvents = "auto";

      document.body.style.overflow = "";
    }, 300);
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const embed = trigger.getAttribute("data-video-embed");
      openModal(embed);
    });
  });

  closeBtn.addEventListener("click", closeModal);
  modalOverlay.addEventListener("click", (e) => {
    if (e.target === modalOverlay) closeModal();
  });
});
